/**
 * @param alias {string} - for renaming the query for ease of use
 */
const marketSelector = (alias = "") => `
  ${alias ? `${alias}:` : ""} globalMarketSelector {
    title
    image {
      alternative: alt
      source: url
    }
  }
`;
export default marketSelector;
